import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router";
import { FiInfo } from "react-icons/fi";
import TestForPackage from "./testsByPackagePopup";
import "./hm-theme.css";

const ProcessAppointmentPopup = ({ isOpen, onRequestClose, payment }) => {
  const [newDate, setNewDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [appointmentExists, setAppointmentExists] = useState(false);
  const [pkg, setPackage] = useState(null);
  const [lab, setLab] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const navigate = useNavigate();

  const userRole = JSON.parse(localStorage.getItem("data")).role;
  const token = JSON.parse(localStorage.getItem("data")).token;

  useEffect(() => {
    if (payment) {
      (async () => {
        setNewDate(payment?.appointmentDate);
        setLoading(true);
        try {
          const labRes = await axios.get(`/api/labdetails/${payment.labId}`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setLab(labRes.data);

          const pkgRes = await axios.get(`/api/package/${payment.packageId}`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setPackage(pkgRes.data);

          const res = await axios.post(`/api/payment/checkAppointmentExist`,
            { paymentId: payment.paymentId },
            { headers: { Authorization: `Bearer ${token}` } }
          );
          setAppointmentExists(res.data === true);
        } catch (error) {
          handleError(error);
          setAppointmentExists(false);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [payment]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newDate) {
      toast.warn("Please select appointment date");
      return;
    }
    const selectedDate = new Date(newDate);
    if (selectedDate.getDay() === 0) {
      toast.warn("Please select a weekday other than Sunday.");
      return;
    }
    setLoading(true);
    try {
      await axios.post("/api/employeeappointment/process-appointment", {
        appointmentDate: newDate,
        packageId: payment.packageId,
        labId: payment.labId,
        userid: payment.userid,
        orderId: payment.orderId
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Employee Lab Appointment processed successfully.");
      onRequestClose();
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  return (
    <>
      <Modal show={isOpen} onHide={onRequestClose} centered>
        <Modal.Header closeButton className="hm-card-header">
          <Modal.Title className="hm-card-title">
            <i className="material-icons">event_available</i>
            Process Appointment
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {loading && <div className="loading"></div>}

          {appointmentExists === true ? (
            <div className="text-center py-4">
              <i className="material-icons" style={{ fontSize: "3rem", color: "#198754" }}>check_circle</i>
              <p className="fw-bold mt-2" style={{ color: "#198754", fontSize: "1.1rem" }}>Payment already validated.</p>
              <p className="text-muted small">This appointment has already been processed.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {/* Lab & Package Info */}
              {(lab || pkg) && (
                <div className="mb-3 p-3 rounded-3 bg-light border">
                  {lab && (
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <i className="material-icons text-muted" style={{ fontSize: "1rem" }}>biotech</i>
                      <span className="small"><strong>Lab:</strong> {lab.labname} ({lab.labcode})</span>
                    </div>
                  )}
                  {pkg && (
                    <div className="d-flex align-items-center gap-2">
                      <i className="material-icons text-muted" style={{ fontSize: "1rem" }}>inventory_2</i>
                      <span className="small"><strong>Package:</strong> {pkg.packagename}</span>
                      <FiInfo
                        onClick={() => { setSelectedPackage(pkg?.id); setIsTestsModalOpen(true); }}
                        style={{ cursor: "pointer", color: "#2cb6e9" }}
                        title="View Package Tests"
                      />
                    </div>
                  )}
                </div>
              )}

              <div className="mb-4">
                <label htmlFor="newDate" className="form-label small fw-semibold">
                  Appointment Date <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="newDate"
                  type={userRole !== 'ROLE_EMPLOYEE' ? "date" : "text"}
                  placeholder="Select appointment date"
                  value={newDate}
                  onChange={userRole !== 'ROLE_EMPLOYEE' ? (e) => setNewDate(e.target.value) : undefined}
                  min={new Date().toISOString().split("T")[0]}
                  required
                />
                <span className="text-muted small">Sundays are not available for appointments.</span>
              </div>

              <div className="d-flex justify-content-end gap-2">
                <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
                  Cancel
                </Button>
                <button type="submit" className="btn-hm-primary" disabled={loading}>
                  <i className="material-icons" style={{ fontSize: "1rem" }}>event_available</i>
                  Process Appointment
                </button>
              </div>
            </form>
          )}
        </Modal.Body>
      </Modal>

      {isTestsModalOpen && (
        <TestForPackage
          isOpen={isTestsModalOpen}
          onRequestClose={() => { setIsTestsModalOpen(false); setSelectedPackage(null); }}
          packageId={selectedPackage}
        />
      )}
    </>
  );
};

export default ProcessAppointmentPopup;
